
import BudgetControlTabs from "./BudgetControlTabs"

const BudgetControl = () => {
  return (
    <>
    <BudgetControlTabs/>
    </>
  )
}

export default BudgetControl